<template>
    <div>
        <vs-tabs alignment="fixed">
            <vs-tab label="Shopping">
                <ListShopping class="mt-4" />
            </vs-tab>

            <vs-tab label="Produtos">
                <ListProdutos class="mt-4" />
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import ListShopping from "./ListShopping.vue";
import ListProdutos from "./ListProdutos.vue";

export default {
    components: {
        ListProdutos,
        ListShopping
    },
}
</script>
